import React, {useEffect, useState} from "react";

import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputNumber} from "primereact/inputnumber";

import {Loading, IndexTemplate} from "../../utils/InlineComponents";
import {AppContext} from "../../HomePage";
import {BotGroupService} from "../../service/BotGroupService";
import AdminPageHeader from "./AdminPageHeader";

const BotGroups = (props) => {

    const {t, toast, setError} = React.useContext(AppContext);

    const [botGroups, setBotGroups] = useState([]);
    const [selectedBotGroupId, setSelectedBotGroupId] = useState(null);
    const [units, setUnits] = useState(1);
    const [loading, setLoading] = useState(false);
    const [spiking, setSpiking] = useState(false);

    const botGroupService = new BotGroupService();

    useEffect(() => {
        search();
    }, []);

    const search = () => {
        setLoading(true);
        botGroupService.getBotGroups().then(data => {
            setBotGroups(data);
            setLoading(false);
        }).catch(error => {
            setError(error);
            setError(null);
            setLoading(false);
        });
    };

    const selectedGroup = botGroups.find(group => group.bot_group_id === selectedBotGroupId);
    const selectedMaxUnits = selectedGroup ? selectedGroup.max_units : 1;

    const onGroupChange = (botGroupId) => {
        setSelectedBotGroupId(botGroupId);
        const group = botGroups.find(g => g.bot_group_id === botGroupId);
        if (group && units > group.max_units)
            setUnits(group.max_units);
    };

    const spike = () => {
        if (!selectedBotGroupId || !units || units < 1) {
            toast.current.show({severity: 'warn', summary: t('bot_group.spike'), detail: t('bot_group.select_group_and_units')});
            return;
        }
        if (units > selectedMaxUnits) {
            toast.current.show({severity: 'warn', summary: t('bot_group.spike'), detail: t('bot_group.max_units_exceeded', {max: selectedMaxUnits})});
            return;
        }
        setSpiking(true);
        botGroupService.spike(selectedBotGroupId, units).then(() => {
            setSpiking(false);
            toast.current.show({severity: 'success', summary: t('bot_group.spike'), detail: t('message_detail.successful')});
            search();
        }).catch(error => {
            setSpiking(false);
            setError(error);
            setError(null);
        });
    };

    const groupOptions = botGroups.map(group => ({value: group.bot_group_id, label: group.name}));

    const unitsTemplate = (rowData) => <span>{rowData.units !== null && rowData.units !== undefined ? rowData.units : '-'}</span>;
    const runningUnitsTemplate = (rowData) => <span>{rowData.running_units_count !== null && rowData.running_units_count !== undefined ? rowData.running_units_count : '-'}</span>;

    return <React.Fragment>

        <div className="card management-page">
            <AdminPageHeader
                title={t('menu_item.bot_groups')}
                subtitle={t('menu.management_hub.page.bot_groups')}
                actions={<>
                    <Button label={t('actions.refresh')} icon="pi pi-refresh" className="p-button-outlined"
                            onClick={search} disabled={loading}/>
                </>}
            />

            <div className="card">
                <h5>{t('bot_group.spike_title')}</h5>
                <p style={{marginTop: 0, color: 'var(--text-color-secondary)'}}>{t('bot_group.spike_description')}</p>
                <div className="p-grid p-fluid p-align-end">
                    <div className="p-col-12 p-md-5">
                        <label htmlFor="bot_group">{t('bot_group.group')}</label>
                        <Dropdown id="bot_group" value={selectedBotGroupId} options={groupOptions}
                                  onChange={(e) => onGroupChange(e.value)}
                                  placeholder={t('bot_group.select_group')} filter showClear/>
                    </div>
                    <div className="p-col-12 p-md-3">
                        <label htmlFor="units">{selectedGroup ? t('bot_group.units_with_max', {max: selectedMaxUnits}) : t('bot_group.units')}</label>
                        <InputNumber id="units" value={units} onValueChange={(e) => setUnits(e.value)}
                                     min={1} max={selectedMaxUnits} disabled={!selectedBotGroupId} showButtons/>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Button label={t('bot_group.spike')} icon="pi pi-bolt" className="p-button-success"
                                loading={spiking} disabled={spiking} onClick={spike}/>
                    </div>
                </div>
            </div>

            {loading ?
                <div className="p-col-12" style={{textAlign: 'center'}}>
                    <Loading/>
                </div> :
                <DataTable value={botGroups}
                           emptyMessage={t('actions.empty_message')}
                           sortField="name" sortOrder={1}>
                    <Column body={IndexTemplate} headerStyle={{width: '3em'}}/>
                    <Column field="name" header={t('bot_group.group')}/>
                    <Column field="bot_group_id" header={t('bot_group.bot_group_id')}/>
                    <Column field="max_units" header={t('bot_group.max_units')}/>
                    <Column field="units" body={unitsTemplate} header={t('bot_group.current_units')}/>
                    <Column field="running_units_count" body={runningUnitsTemplate} header={t('bot_group.running_units')}/>
                </DataTable>}
        </div>

    </React.Fragment>;
};
export default BotGroups;
